
import {IDS} from "./pnp-settings-document-category.constants";

export const addCategoryAddState = {
    name: IDS.app_policies_settings_categories_add,
    redirectTo: IDS.app_policies_settings_categories_add_details,
    url: '/add',
    component: 'tabs'
};

export const pnpDocumentCategoryAddDetailsState = {
    name: IDS.app_policies_settings_categories_add_details,
    url: '',
    component: 'pnpSettingsDocumentCategoryDetails',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'PNP_DOCUMENT_CATEGORY_RESET',
            id: 'pnpSettingsDocumentCategory'
        });
    }
};

export const pnpDocumentCategoryManageState = {
    name: IDS.app_policies_settings_categories_manage,
    redirectTo: IDS.app_policies_settings_categories_manage_listing,
    url: '/manage',
    component: 'tabs'
};

export const pnpDocumentCategoryManageListingState = {
    name: IDS.app_policies_settings_categories_manage_listing,
    url: '',
    component: 'pnpSettingsDocumentCategoryGrid',
    /* @ngInject */
    onEnter: ($ngRedux) => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id:IDS.app_policies_settings_categories_manage,
            state: [IDS.app_policies_settings_categories_manage_details]
        });
    }
};

export const pnpDocumentCategoryManageDetailsState = {
    name: IDS.app_policies_settings_categories_manage_details,
    url: '/details?id',
    component: 'pnpSettingsDocumentCategoryDetails'
};
